import * as yup from "yup";
import {
  VALID_AMBULANCE_DETAILS,
  VALID_CCTV,
  VALID_COMMENT,
  VALID_CUSTOMERS_ARRAY,
  VALID_DATE,
  VALID_DESCRIPTION,
  VALID_ES_CALLED,
  VALID_ES_TYPES,
  VALID_INCIDENT_NUMBER,
  VALID_INCIDENT_TYPE,
  VALID_INJURY_DETAILS,
  VALID_IS_INJURED,
  VALID_OFFICER,
  VALID_SERVICES_ARRIVED_TIME,
  VALID_SERVICES_DID_NOT_ATTEND,
  VALID_TIME_SERVICES_CONTACTED,
  TIME_NOT_IN_FUTURE,
} from "@common/constants/validation";

export const customerIncidentSchema = yup.object().shape({
  searchedCustomer: yup.string().notRequired(),
  date: VALID_DATE,
  time: TIME_NOT_IN_FUTURE,
  customerIncidentType: VALID_INCIDENT_TYPE,
  customers: VALID_CUSTOMERS_ARRAY,
  description: VALID_DESCRIPTION,
  capturedByCctv: VALID_CCTV,
  injuries: VALID_IS_INJURED,
  injuryDetails: VALID_INJURY_DETAILS,
  esCalled: VALID_ES_CALLED,
  esTypes: VALID_ES_TYPES,
  ambulanceDetails: VALID_AMBULANCE_DETAILS,
  timeServicesContacted: VALID_TIME_SERVICES_CONTACTED,
  servicesDidNotAttend: VALID_SERVICES_DID_NOT_ATTEND,
  timeServicesArrived: VALID_SERVICES_ARRIVED_TIME,
  officer: VALID_OFFICER,
  incidentNumber: VALID_INCIDENT_NUMBER,
  comments: VALID_COMMENT,
});
